import React, { Component, PropTypes as pt } from 'react';
import { Link } from 'react-router-dom'

import Modal from '../../../common/components/Modal';

class Channel extends Component {
    constructor (props) {
        super(props);

        this.state = {
            modal: false,
            edited: false,
            value: false
        };

        this.renderSelectModal = this.renderSelectModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.getPreferenceName = this.getPreferenceName.bind(this);
        // this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.edited) {
            this.setState({
                edited: false,
                value: nextProps.value
            });
        }
    }

    toggleModal (ev) {
        ev && ev.preventDefault();
        this.setState({
            modal: !this.state.modal
        });
    }

    handleSelect (id, ev) {
        ev && ev.preventDefault();

        // If assigned is clicked remove its assignment.
        const { value } = this.state;
        if (id == value) id = false;

        this.setState({
            value: id,
            edited: true,
            modal: false
        });
        this.props.storeEdits(id);
    }

    getPreferenceName () {
        const { value } = this.state;
        const { channels } = this.props;
        var name = '';

        Object.keys(channels.data).map(function (channel, index) {
            const c = channels.data[channel];
            if (c.preferenceID == value) {
                name = c.preference.name;
            }
        }, this);

        return name;
    }

    render () {

        console.log(this.state);

        const value = (this.state.edited) ?
            this.state.value :
            this.props.value;

        return (<div>
            <div className="input-group">
                <span className="input-group-btn">
                    <button className="btn btn-primary"
                        onClick={this.toggleModal}>
                            Select Channel
                    </button>
                </span>
                <input type="text"
                    readOnly
                    value={this.getPreferenceName()}
                    className="form-control"
                    placeholder="No Channel Selected" />
            </div>

            {this.renderSelectModal(value)}
        </div>);
    }

    renderSelectModal (value) {
        if (this.state.modal) {

            const channels = this.props.channels.data;
            var renderedChannels;

            if (Object.keys(channels).length) {
                renderedChannels = Object.keys(channels).map(function (c, i) {

                    const channel = channels[c];
                    const isSelected = channel.preferenceID == value;
                    var action;

                    if (isSelected) {
                        action = <button className="btn btn-block btn-success"
                            onClick={this.handleSelect.bind(null, channel.preferenceID)}>
                                <i className="fa fa-check"/> Assigned
                        </button>;
                    } else {
                        action = <button className="btn btn-block btn-default"
                            onClick={this.handleSelect.bind(null, channel.preferenceID)}>
                                Assign
                        </button>
                    }

                    return (<div className="panel panel-body" key={i}>
                        <div className="col-sm-10">
                            <h4>{channel.preference.name}</h4>
                        </div>
                        <div className="col-sm-2">{action}</div>
                    </div>);
                }, this);
            } else {
                renderedChannels = (<div className="alert alert-info">
                    <h4>No Channels available.</h4>
                    <p>Create one <Link to="/manage/listing">here &hellip;</Link></p>
                </div>);
            }

            return <Modal
                cancelModal={this.toggleModal}>
                <Modal.Header>
                    Select a Channel
                </Modal.Header>
                <Modal.Body>
                    {renderedChannels}
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>
        }
    }
}

Channel.propTypes = {};

export default Channel;
